// Spinner.jsx
import React from 'react';

const Spinner = () => {
 return (
    <div className="relative w-4 h-4">
      {[...Array(8)].map((_, i) => (
        <span
          key={i}
          className="absolute w-3 h-3 top-1/2 left-1/2 w-[2px] h-[2px] bg-blue-500 rounded-full opacity-30"
          style={{
            transform: `rotate(${i * 45}deg) translate(6px)`,
            animation: 'winSpinFade 1s linear infinite',
            animationDelay: `${i * 0.125}s`,
          }}
        />
      ))}

      <style jsx>{`
        @keyframes winSpinFade {
          0% { opacity: 1; }
          100% { opacity: 0.3; }
        }
      `}</style>
    </div>
  );
};

export default Spinner;
